var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from "graphql-tag";
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames";
import fullSavedCard from "../fragments/fullSavedCard";
var query = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query SavedCardsForProvider($provider: PaymentProvider!) {\n    savedCards(provider: $provider) {\n      results {\n        ...fullSavedCard\n      }\n    }\n  }\n  ", "\n"], ["\n  query SavedCardsForProvider($provider: PaymentProvider!) {\n    savedCards(provider: $provider) {\n      results {\n        ...fullSavedCard\n      }\n    }\n  }\n  ", "\n"])), fullSavedCard);
export var toString = query.loc.source.body;
export var savedCardsKey = getQueryNames(query)[0];
export default query;
var templateObject_1;
